"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.responsiveprops = exports.networkFrameChangeProps = exports.orFrameChangeProps = exports.xyFrameChangeProps = exports.xyFrameDataProps = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//size is a special case and handled checking the actual values in the size array
var xyFrameDataProps = ["lines", "points", "summaries", "xScaleType", "yScaleType", "xAccessor", "yAccessor", "lineDataAccessor", "areaDataAccessor", "summaryDataAccessor", "lineType", "showLinePoints", "showSummaryPoints", "defined", "summaryType"];
exports.xyFrameDataProps = xyFrameDataProps;
var xyFrameChangeProps = [].concat(xyFrameDataProps, ["name", "title", "margin", "axes", "position", "xExtent", "yExtent", "invertX", "invertY", "hoverAnnotation", "additionalDefs", "defined", "lineStyle", "pointStyle", "summaryStyle", "lineClass", "pointClass", "areaClass", "summaryClass", "canvasPoints", "customPointMark", "customLineMark", "lineIDAccessor"]);
exports.xyFrameChangeProps = xyFrameChangeProps;
var orFrameChangeProps = ["data", "name", "orient", "title", "margin", "format", "position", "oScaleType", "rScaleType", "oExtent", "rExtent", "invertO", "invertR", "oAccessor", "rAccessor", "oPadding", "projection", "type", "summaryType", "connectorType", "className", "additionalDefs", "renderKey", "dataAccessor", "rBaseline", "sortO", "oSort", "dynamicColumnWidth", "renderFn", "style", "connectorStyle", "summaryStyle", "summaryPosition", "oLabel", "axes"];
exports.orFrameChangeProps = orFrameChangeProps;
var networkFrameChangeProps = ["name", "graph", "nodes", "edges", "title", "margin", "position", "nodeIDAccessor", "sourceAccessor", "targetAccessor", "nodeSizeAccessor", "customNodeIcon", "nodeLabels", "edgeWidthAccessor", "networkType", "className", "additionalDefs", "renderFn", "nodeStyle", "edgeStyle", "edgeType", "filterRenderedNodes"];
exports.networkFrameChangeProps = networkFrameChangeProps;
var sharedframeproptypes = {
  useSpans: true,
  title: true,
  margin: true,
  name: true,
  dataVersion: true,
  frameKey: true,
  size: true,
  position: true,
  canvasPostProcess: true,
  additionalDefs: true,
  className: true,
  customHoverBehavior: true,
  customClickBehavior: true,
  customDoubleClickBehavior: true,
  hoverAnnotation: true,
  disableContext: true,
  interaction: true,
  svgAnnotationRules: true,
  htmlAnnotationRules: true,
  tooltipContent: true,
  optimizeCustomTooltipPosition: true,
  annotations: true,
  baseMarkProps: true,
  backgroundGraphics: true,
  foregroundGraphics: true,
  beforeElements: true,
  afterElements: true,
  annotationSettings: true,
  renderKey: true,
  renderOrder: true,
  legend: true,
  onUnmount: true,
  sketchyRenderingEngine: true,
  interactionSettings: true,
  frameRenderOrder: true
};
var responsiveprops = {
  responsiveWidth: true,
  responsiveHeight: true,
  debounce: true
};
exports.responsiveprops = responsiveprops;


//////////////////
// WEBPACK FOOTER
// ./node_modules/semiotic/lib/constants/frame_props.js
// module id = 277
// module chunks = 0